import React from 'react';
import ReactMarkdown from 'react-markdown';
import './AnswerBubble.css';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coldarkDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const AnswerBubble = ({ text }) => {
    const components = {
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '');
          const isCodeBlock = match || String(children).includes('\n');
          if (!inline && isCodeBlock) {
            const language = match ? match[1] : 'python';
            return (
              <div className="my-4">
                <SyntaxHighlighter
                  language={language}
                  style={coldarkDark}
                  PreTag="div"
                  className="rounded-lg"
                  {...props}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              </div>
            );
          }
          return (
            <code className="bg-gray-100 px-1 rounded" {...props}>
              {children}
            </code>
          );
        }
    };

    return (
        <div className="answer-bubble">
            <ReactMarkdown
              components={components}
              className="markdown-content"
            >{text}
            </ReactMarkdown>
        </div>
    );
};

export default AnswerBubble;

